var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBallRewardMilestone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5701_38561)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.89258,
    y: 4.50977,
    width: 38.4567,
    height: 38.4567,
    rx: 19.2284,
    transform: "rotate(4.31287 5.89258 4.50977)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.35356,
    y: 5.04595,
    width: 37.4567,
    height: 37.4567,
    rx: 18.7284,
    transform: "rotate(4.31287 6.35356 5.04595)",
    stroke: "var(--borderColor, #E28F08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2869 11.9628C32.2869 11.9628 30.6684 12.8253 28.3673 15.0551C28.8713 15.3434 29.4473 15.7398 29.8074 16.028C29.4478 16.3517 29.1243 16.6753 28.8006 16.963C27.3244 15.7381 25.7766 15.125 24.553 14.8361C24.9486 14.5484 25.3801 14.2608 25.7757 14.0092C26.4236 14.1897 27.0355 14.4421 27.0355 14.4421C29.6246 12.4646 31.8549 11.6385 31.8549 11.6385C31.8549 11.6385 31.6029 11.4943 30.9192 11.5298C20.7723 11.6657 11.4589 19.2168 13.2324 32.1756C13.4135 33.5435 13.9552 36.0634 14.6398 37.1438C14.8539 34.9844 15.6777 30.234 18.0844 25.1249C17.2566 24.8363 16.5728 24.6918 16.5728 24.6918C16.8243 24.1881 17.1476 23.5045 17.1476 23.5045C18.911 23.8298 20.4948 24.5869 21.863 25.6678C21.5396 26.2074 21.324 26.5312 21.1443 26.819C20.6762 26.4587 20.1722 26.1343 19.6682 25.81C16.9733 30.5229 15.7175 34.9851 15.2156 37.3242C15.2517 37.4682 15.5396 37.5404 15.7915 37.5046C26.9089 36.0737 32.0859 30.427 33.6642 24.2734C34.7044 20.2431 34.3412 16.0316 32.9711 12.5752C32.791 12.3231 32.6107 11.9271 32.2869 11.9628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25655 21.4886L6.52325 20.4915L7.66243 20.8054L8.3497 19.7662L8.40768 21.0108L9.54686 21.3247L8.40637 21.8054L8.42934 23.0524L7.69126 22.1143L6.57684 22.542L7.25655 21.4886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3132 22.6058L10.5799 21.6087L11.7191 21.9226L12.4063 20.8834L12.4643 22.128L13.6035 22.4418L12.463 22.9226L12.486 24.1696L11.7479 23.2315L10.6335 23.6592L11.3132 22.6058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31319 17.6487L7.57989 16.6517L8.71907 16.9656L9.40634 15.9263L9.46432 17.1709L10.6035 17.4848L9.46301 17.9656L9.48598 19.2126L8.7479 18.2744L7.63348 18.7021L8.31319 17.6487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3718 18.7669L11.6385 17.7699L12.7777 18.0837L13.4649 17.0445L13.5229 18.2891L14.6621 18.603L13.5216 19.0837L13.5446 20.3307L12.8065 19.3926L11.6921 19.8203L12.3718 18.7669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4831 34.1703L37.7463 33.2337L36.6337 33.6607L37.291 32.6032L36.5589 31.6078L37.7069 31.9241L38.393 30.8866L38.4509 32.1291L39.5882 32.4425L38.4496 32.9224L38.4831 34.1703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4441 33.057L33.7072 32.1204L32.5946 32.5474L33.252 31.4899L32.5199 30.4945L33.6572 30.8079L34.3433 29.7704L34.4012 31.0129L35.5385 31.3263L34.3999 31.8062L34.4441 33.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5417 30.3256L38.8049 29.389L37.6923 29.816L38.3496 28.7585L37.6175 27.7631L38.7654 28.0794L39.4516 27.0418L39.5095 28.2844L40.6468 28.5978L39.5082 29.0777L39.5417 30.3256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5027 29.2123L34.7658 28.2757L33.6532 28.7027L34.3105 27.6452L33.5785 26.6498L34.7158 26.9632L35.4019 25.9256L35.4598 27.1682L36.5971 27.4815L35.4585 27.9615L35.5027 29.2123Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5701_38561",
    x: -0.845675,
    y: -1.25875,
    width: 48.9316,
    height: 48.9316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.92284
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5701_38561"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5701_38561",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallRewardMilestone);
export default __webpack_public_path__ + "static/media/ball_reward_milestone.8ab4766c.svg";
export { ForwardRef as ReactComponent };